// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__2c3j1","obliqueLineWrap":"membershipbadge_obliqueLineWrap__GL5UP","obliqueLine":"membershipbadge_obliqueLine__LdLbT"};